module.exports = {
  SET_HEX_CODE: "SET_HEX_CODE",
  RESET_HEX_CODE: "RESET_HEX_CODE"
};